const NAME = "ISSUE_TYPES_SETTINGS";

export default NAME;
